'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fitnessTrendsOnEnter = fitnessTrendsOnEnter;

var _effects = require('redux-saga/effects');

var _env = require('helpers/env');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fitnessTrendsOnEnter);

// Ignoring testing since this is temporary until feature release
/* istanbul ignore next */
function fitnessTrendsOnEnter(store, nextState, replaceState) {
  return _regenerator2.default.wrap(function fitnessTrendsOnEnter$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_env.isProduction);

        case 2:
          if (!_context.sent) {
            _context.next = 6;
            break;
          }

          _context.next = 5;
          return (0, _effects.call)(replaceState, '/');

        case 5:
          return _context.abrupt('return', _context.sent);

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}